import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { PostplaceSelectionItem, PostplaceService } from '@app/services/postplace.service';
import { TypeaheadService } from '@app/services/typeahead.service';

@Component({
    selector: 'tt-select-city',
    templateUrl: './select-city.component.html',
    styleUrls: ['./select-city.component.css'],
    standalone: false
})
export class SelectCityComponent implements OnInit {
    public items: PostplaceSelectionItem[] = [];

    public searchText = '';

    public loading = false;

    public error = '';

    private webpage = '';

    private parm = '';

    constructor(
        private postplace: PostplaceService,
        private typeahead: TypeaheadService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        this.webpage = String(this.navigator?.params['webpage_name'] ?? '');
        this.parm = String(this.navigator?.params['parm1'] ?? '');
        this.searchText = this.postplace.initialize(this.webpage, this.parm);

        if (this.searchText !== '') await this.search();
    }

    public async search(): Promise<void> {
        if (this.loading) return;

        this.loading = true;
        this.error = '';
        this.postplace.rememberSearch(this.webpage, this.parm, this.searchText);

        try {
            // Empty searches retain the previous results, as in the legacy selector.
            if (typeof this.searchText === 'string' && this.searchText.length > 0) {
                this.items = await this.typeahead.searchPostplaces({
                    webpage_name: this.webpage,
                    parm1: this.parm,
                    searchtext: this.searchText
                });
            }
        } catch (error) {
            this.error = error instanceof Error ? error.message : String(error);
        } finally {
            this.loading = false;
        }
    }

    public clearSearch() {
        this.searchText = '';
        this.items = [];

        if (this.searchText === '') this.postplace.rememberSearch(this.webpage, this.parm, this.searchText);
    }

    public select(item: PostplaceSelectionItem): void {
        if (item.item_id === '') return;

        this.postplace.select(item);
        this.navigator?.back();
    }
}
